import React from "react";
import BaseIntroSection from "../../common/BaseIntroSection";

import Post1 from "./assets/pm_1.jpg";
import Post2 from "./assets/pm_2.jpg";

import Post1_2x from "./assets/2x/pm_1.jpg";
import Post2_2x from "./assets/2x/pm_2.jpg";

import "./PlaymemoriesPageSection.scss";

const Screenshots = () => ([
	<img key="1" className="screenshot screenshot1 border-radius-small" src={Post1} srcSet={`${Post1_2x } 2x`} />,
	<img key="2" className="screenshot screenshot1 border-radius-small" src={Post2} srcSet={`${Post2_2x} 2x`} />,
]);

export const PlaymemoriesIntroSection = () => (
	<BaseIntroSection
		mainText="PlayMemories Mobile + Web App"
		subText="Enabling users to share and view their photos and videos from any device, anywhere"
		aboutText="Sony's PlayMemories Online product aims at helping users share and view their photos and videos from any device, anywhere. The design goal was simple, create a seamless experience for Sony customers to get access their photos and videos from their cameras and phones across all their favorite devices from their iPhone, iPad, Bravia TVs, and online. The suite of products include an online web portal, iOS and Android smartphones, and tablet, as well as integration within Sony desktop applications. I was the main interaction designer for web and mobile as well as visual designer for iOS products. In designing for various platforms, keeping the interactions consistent and simple as well as keeping within all the constraints of different devices and platforms was key. I was the lead designer on this project working with a small engineering team from 2011 to 2012."
	>
	<div className="desktop-max-width-large">
		<Screenshots />
	</div>
	</BaseIntroSection>
);



// WEBPACK FOOTER //
// ./src/components/pages/playmemories/PlaymemoriesPageSection.js